import React from 'react';
import { Mail, Calendar, Instagram, Youtube, Linkedin } from 'lucide-react';
import '../CSS/Footer.css'

const Footer = () => {
  const currentYear = new Date().getFullYear();

  const socialLinks = [
    { icon: Mail, href: 'mailto:info@aikanksha.com', label: 'Email' },
    { icon: Instagram, href: 'https://instagram.com/aikanksha', label: 'Instagram' },
    { icon: Youtube, href: 'https://youtube.com/@aikanksha', label: 'YouTube' },
    { icon: Linkedin, href: 'https://linkedin.com/in/akanksha-mhaske', label: 'LinkedIn' }, // ✅ added
    { icon: Calendar, href: 'https://cal.com/akankshaa/30-min-call', label: 'Schedule Call' }
  ];

  const quickLinks = [
    { label: 'About', href: '#about' },
    { label: 'Services', href: '#services' },
    { label: 'Portfolio', href: '#portfolio' },
    { label: 'AI Tools', href: '#tools' },
    { label: 'Blogs', href: '#blogs' },
    { label: 'Contact', href: '#contact' }
  ];

  const scrollToSection = (href) => {
    const element = document.querySelector(href);
    element?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer className="footer">
      <div className="footer-container">
        <div className="footer-top-grid">
          {/* Brand */}
          <div className="footer-brand">
            <div className="brand-logo">
              <div className="brand-circle pulse-glow">
                <span>A</span>
              </div>
              <span className="brand-name">aikanksha</span>
            </div>
            <p className="brand-description">
              Empowering businesses and professionals to harness the transformative power of AI. 
              Making advanced technology accessible, practical, and profitable.
            </p>
            <div className="social-icons">
              {socialLinks.map(({ icon: Icon, href, label }) => (
                <a
                  key={label}
                  href={href}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="social-link"
                  aria-label={label}
                >
                  <Icon size={18} />
                </a>
              ))}
            </div>
          </div>

          {/* Quick Links */}
          <div className="footer-quick-links">
            <h4>Quick Links</h4>
            <ul>
              {quickLinks.map(({ label, href }) => (
                <li key={label}>
                  <button
                    onClick={() => scrollToSection(href)}
                    className="quick-link-btn"
                  >
                    {label}
                  </button>
                </li>
              ))}
            </ul>
          </div>

          {/* Contact Info */}
          <div className="footer-contact">
            <h4>Get Started</h4>
            <a href="mailto:contact@aikanksha.com" className="contact-email">
              contact@aikanksha.com
            </a>
            <a
              href="https://cal.com/akankshaa/30-min-call"
              target="_blank"
              rel="noopener noreferrer"
              className="book-call-btn"
            >
              Book Free Call
            </a>
          </div>
        </div>

        {/* Divider */}
        <div className="footer-bottom">
          <div className="copyright">
            © {currentYear} Aikanksha.
           Crafted to unlock the power of AI for you.
          </div>
          <div className="footer-legal">
            <button className="legal-btn">Privacy Policy</button>
            <button className="legal-btn">Terms of Service</button>
          </div>
        </div>

        {/* Floating Dots */}
        <div className="floating-dot dot1" />
        <div className="floating-dot dot2" />
        <div className="floating-dot dot3" />
      </div>
    </footer>
  );
};

export default Footer;
